import React from "react";
import Skeleton from "react-loading-skeleton";

const TnspCard = () => {
  return (
    <div className="transparent-card">
      <div className="transparent-img">
        <Skeleton
          width={50}
          height={50}
          className="custom-skeleton"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.20)",
          }}
        />
      </div>
      <div className="transparent-card__content">
        <Skeleton
          width={"70px"}
          height={"16px"}
          className="custom-skeleton"
          style={{
            // margin:'0px',
            marginTop:"5px",
            backgroundColor: "rgba(255, 255, 255, 0.20)",
          }}
        />
        <Skeleton
          width={"92px"}
          height={"16px"}
          className="custom-skeleton"
          style={{
            margin:'0px',
            backgroundColor: "rgba(255, 255, 255, 0.10)",
          }}
        />
      </div>

      <Skeleton
        width={"48px"}
        height={"48px"}
        circle
        className="custom-skeleton"
        style={{
          marginRight: "10px",
          backgroundColor: "rgba(255, 255, 255, 0.70)",
        }}
      />
    </div>
  );
};

export default TnspCard;
